// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3827bd2","455":"399c9c5f"}[chunkId] + ".chunk.js";
};